<template>
  <div class="self-exclusion-form">
    <h3 class="title">
      <font-awesome-icon :icon="['fas', 'ban']" class="anticon" />
      {{ labels.title }}
    </h3>
    <span class="subtitle">
      {{ labels.subtitle }}
    </span>

    <ValidationObserver ref="observerSelfExclusion">
      <a-form
        slot-scope="{ validate }"
        :label-width="80"
        @submit.prevent="validate().then(onSubmit)"
      >
        <!-- Form fields go here -->
        <a-row :gutter="16">
          <a-col :xs="24" :sm="24" :md="12">
            <SelectPagination
              :data="options.exclusionPeriods"
              v-model="form.exclusionPeriod"
              rules="required"
              vid="exclusionPeriod"
              :placeholder="labels.form.exclusionPeriod.placeholder"
              :allowClear="true"
              :label="labels.form.exclusionPeriod.label"
              :labelKey="'label'"
              :valueKey="'value'"
              size="large"
            />
          </a-col>
        </a-row>
        <a-form-item>
          <a-button
            :disabled="submitting"
            type="primary"
            size="large"
            @click="validate().then(onSubmit)"
          >
            {{ labels.form.save }}
          </a-button>
        </a-form-item>
      </a-form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import _ from "lodash";
import SelectPagination from "@/components/core/SelectPagination/index.vue";
import { mapActions } from "vuex";
const defaultState = {
  exclusionPeriod: null,
};
export default {
  name: "SelfExclusionForm",
  components: {
    ValidationObserver,
    SelectPagination,
  },
  props: {
    labels: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: _.cloneDeep(defaultState),
      submitting: false,
      options: {
        exclusionPeriods: [
          { label: "6 meses", value: "6_months" },
          { label: "1 año", value: "1_year" },
          { label: "2 años", value: "2_years" },
          { label: "5 años", value: "5_years" },
          { label: "Indefinido", value: "indefinite" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("responsibleGaming", ["setAutoExclusion"]),
    async onSubmit() {
      if (this.submitting) return;
      try {
        this.submitting = true;
        await this.setAutoExclusion({
          exclusionPeriod: this.form.exclusionPeriod?.value,
        });

        this.$store.dispatch("clientAuth/checkSession");

        this.$success({
          class: "success-modal",
          title: this.labels.success,
          centered: true,
          width: this.isMobile ? "100%" : "600px",
        });
      } catch (error) {
        if (error.isAxiosError && error.response.status === 400) {
          this.$notification["error"]({
            message: error.response?.data?.message || error.response?.message,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.length
                  ? error.response?.data?.additional_errors?.map((error) => {
                      return h("li", error);
                    })
                  : h("li", error.response?.data?.message)
              );
            },
          });
        } else {
          this.$notification["error"]({
            message:
              error?.response?.data?.message ||
              error?.response?.message ||
              error.message,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.self-exclusion-form {
  .title {
    border-bottom: 1px solid var(--border-color);
    color: var(--text);
  }
  .subtitle {
    display: block;
    margin-bottom: 24px;
    color: var(--text);
  }
}
</style>
